import { render, staticRenderFns } from "./PostersNav.vue?vue&type=template&id=39bda3f4&scoped=true&"
import script from "./PostersNav.vue?vue&type=script&lang=js&"
export * from "./PostersNav.vue?vue&type=script&lang=js&"
import style0 from "./PostersNav.vue?vue&type=style&index=0&id=39bda3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bda3f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39bda3f4')) {
      api.createRecord('39bda3f4', component.options)
    } else {
      api.reload('39bda3f4', component.options)
    }
    module.hot.accept("./PostersNav.vue?vue&type=template&id=39bda3f4&scoped=true&", function () {
      api.rerender('39bda3f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/PostersNav.vue"
export default component.exports